import DDLogs from '@/DDLogs';
import NatiApi from '../../api/NatiApi';

const state = {
  initialized: false,
  hasPushTokens: false,
  shouldSendPush: false,
};

const getters = {
  hasPushTokens: state => state.hasPushTokens,
  shouldSendPush: state => state.shouldSendPush,
};

const actions = {
  async initPushNotifications({ commit, state }) {
    if (state.initialized) {
      return;
    }

    try {
      const pushTokensResponse = await NatiApi.getPushTokenInfo();
      commit('setHasPushTokens', pushTokensResponse.hasPushTokens);
      commit('setShouldSendPush', pushTokensResponse.shouldSendPush);
      commit('setInitialized', true);
    } catch (error) {
      DDLogs.error('Failed to fetch push token info', error);
      commit('setInitialized', true);
    }
  },

  async updateShouldSendPush({ commit }, shouldSendPush) {
    await NatiApi.updateShouldSendPush(shouldSendPush);
    commit('setShouldSendPush', shouldSendPush);
  },

  setHasPushTokens({ commit }, hasPushTokens) {
    commit('setHasPushTokens', hasPushTokens);
  },
};

const mutations = {
  setHasPushTokens(state, hasPushTokens) {
    state.hasPushTokens = hasPushTokens;
  },
  setShouldSendPush(state, shouldSendPush) {
    state.shouldSendPush = shouldSendPush;
  },
  setInitialized(state, initialized) {
    state.initialized = initialized;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
